module.exports = __webpack_public_path__ + "static/media/rtvlogo.9052a4c2ab94622e4e4c96f8cc002369.png";